import { Row, Col } from 'antd';
import styled from 'styled-components';

export const ImageDZContainer = styled.div`
  justify-self: end;
  width: 100%;
`;

export const ErrorCol = styled(Col)`
  text-align: end;
  color: ${({ theme }) => theme.red.a10};
  padding: 5px 20px;
`;

export const RelativeContainer = styled.div`
  position: relative;
`;

export const ButtonRow = styled(Row)`
  padding: 1rem 0;
`;

export const ButtonContainer = styled.div`
  display: flex;
`;

export const TemplateError = styled.div`
  color: ${({ theme }) => theme.red.a10};
  font-style: italic;
  font-weight: 300;
  font-size: 0.8rem;
  padding: 0 0 1rem 1rem;
`;

export const FieldWrapper = styled.div`
  width: 33.33%;
  &:nth-child(3n + 2) {
    padding: 0 9px;
  }
`;

export const InputsContainer = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
`;
